'use client';

import { Button } from '@/components/ui/button';
import { useDictionary } from '@/lib/context/locale-provider';
import { Languages } from '@/lib/dictionaries';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import React from 'react';
import '@/app/input.css';
import CartEmptyImage from '@/public/images/cart_empty.png';

function CartEmpty({ lang }: { lang: Languages }) {
  const dict = useDictionary();
  const router = useRouter();

  const handleBrowseProducts = () => {
    try {
      window.flutter_inappwebview.callHandler('cartBrowseProductsClick');
    } catch (e) {
      router.push(`/${lang}`);
    }
  };

  return (
    <div className="w-full h-[calc(100vh-60px)] lg:h-[calc(100vh-80px)] flex flex-col items-center gap-5 pt-[120px] lg:pt-[220px]">
      <Image src={CartEmptyImage} alt={'Cart Empty'} width={200} height={200} />
      <p className="font-bold text-2xl giftifan5">{dict!.cart.cartIsEmpty}</p>
      <div className="mt-5 basic-shadow w-full lg:w-[360px] px-5 py-[15px] lg:p-0 fixed bottom-0 lg:relative lg:shadow-none bg-white">
        <Button
          className="bg-gradient-giftifan w-full font-bold text-lg"
          onClick={handleBrowseProducts}
        >
          {dict!.cart.browseProducts}
        </Button>
      </div>
    </div>
  );
}

export default CartEmpty;
